import { createContext } from '@companydotcom/potion';
const [SourceConfigProvider, useSourceConfig] = createContext({
    name: 'SourceConfigContext',
    errorMessage: 'useSource: `source` is undefined. Seems you forgot to wrap the app in `<SourceProvider />` ',
});
export { SourceConfigProvider, useSourceConfig };
